import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

export type DevicePark = {
  code: string;
  selected: boolean;
}

@Component({
    selector: 'app-data-unified-items',
    templateUrl: './data-unified-items.component.html',
    styleUrls: ['./data-unified-items.component.scss'],
    standalone: false
})
export class DataUnifiedItemsComponent implements OnChanges {
  @Input() items: DevicePark[];
  @Input() disabled: boolean;
  @Output() selectedItems = new EventEmitter<DevicePark[]>();
  @Input() title: string;
  @Input() type: 'metmast' | 'controlSystem' = 'controlSystem';
  public closedList = true;
  public allSelected = false;
  public toggleClick: boolean;
  public selectedItemsList: DevicePark[] = [];

  constructor(private eRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target) && !this.toggleClick) {
      this.closedList = true;
    }
    this.toggleClick = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items?.currentValue !== null) {
      this.selectAllItems();
    }
  }

  public get getSelected(): number {
    return this.items.filter((item) => item.selected).length;
  }

  public get selectedList() {
    const selectedControlSystem = this.items
      .filter(item => item.selected)
      .map(item => item.code);
    return selectedControlSystem.join(', ');
  }

  public toggleList(): void {
    this.toggleClick = true;
    this.closedList = !this.closedList;
  }

  public selectAllItems(): void {
    this.allSelected = !this.allSelected;
    this.items.forEach((item) => {
      item.selected = this.allSelected;
      return item;
    });
    this.selectedItemsList = this.allSelected ? this.items : [];
    this.emitSelectedItems();
  }

  public selectItem(event: MatCheckboxChange, device: DevicePark): void {
    device.selected = event.checked;
    if (event.checked) {
      this.selectedItemsList.push(device);
    } else {
      this.selectedItemsList = this.selectedItemsList.filter(item => item.code !== device.code);
    }
    this.allSelected = this.items.length === this.selectedItemsList.length;
    this.emitSelectedItems();
  }

  private emitSelectedItems(): void {
    this.selectedItems.emit(this.selectedItemsList);
  }
}